const $inject = ['$filter', 'moment'];

const lbTripOptionsHotelFormItemCtrl = function ($filter, moment) {
  let vm = this;

  const timeFormat = $filter('translate')('dates.TimeFormatLong');

  vm.flightDateTimeFormat = `DD MMM[,] YYYY ${timeFormat}`;
};

lbTripOptionsHotelFormItemCtrl.$inject = $inject;

export default lbTripOptionsHotelFormItemCtrl;



// WEBPACK FOOTER //
// ./src/components/lbTripOptionsModal/lbTripOptionsHotelFormItemCtrl.js